import { ChangeDetectionStrategy, Component, HostBinding } from "@angular/core";

@Component({
    selector: "sps-button-group",
    templateUrl: "./sps-button-group.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpsButtonGroupComponent {
    static readonly displayName = "sps-button-group";
    static readonly props = {};

    @HostBinding("class.sps-button-group") readonly _spsButtonGroupClass = true;
}
